import React from 'react';
import { Redirect } from 'react-router-dom';

/**
 * Composant de route : redirige (replace) vers `to` en conservant la query string.
 * Sert aux anciennes URL décâblées (ex. formulaires Darty → /connexion) ; dans la
 * configuration des routes, `to` est préfixé par la locale comme `path` (localizeRoutes).
 */
const RedirectComponent = ({ to, location }) => (
    <Redirect to={{ pathname: to, search: location.search }} />
);

export default RedirectComponent;



// WEBPACK FOOTER //
// ./src/components/router/RedirectComponent.js